import React, { useContext, useState } from "react";
import Context from "../../../../Context";
import List from "../../../Misc/List";
import Filters from "../../../Misc/Filters";
import Sortings from "../../../Misc/Sortings";

const STATE_TRUSTED = parseInt("100", 2);
const STATE_LOCAL = parseInt("010", 2);
const STATE_EXTERNAL = parseInt("001", 2);

const STATUS_EXPIRED = parseInt("1000", 2);
const STATUS_LOCKED = parseInt("0100", 2);
const STATUS_ACTIVE = parseInt("0010", 2);
const STATUS_OPEN = parseInt("0001", 2);

function ActiveSessions() {
  const cx = useContext(Context);

  let search = [];
  let sort = ["created DESC"];

  const [currentSearchJSON, changeCurrentSearch] = useState(
    JSON.stringify(search || [])
  );

  const [currentSortingsJSON, changeCurrentSortings] = useState(
    JSON.stringify(sort || [])
  );

  const [showfilters, toggleFilters] = useState(false);

  function filtersChange(search) {
    changeCurrentSearch(JSON.stringify(search));
  }

  function sortingsChange(sortings) {
    changeCurrentSortings(JSON.stringify(sortings));
  }

  let flt = [
    {
      id: "name",
      title: cx.t("admin.activeSessions.filter_userid"),
      kind: "mask",
      value: "",
    },
    {
      id: "created",
      title: cx.t("admin.activeSessions.filter_created"),
      kind: "range",
      active: false,
      value: [],
    },
    {
      id: "updated",
      title: cx.t("admin.activeSessions.filter_updated"),
      kind: "range",
      active: false,
      value: [],
    },
    {
      id: "state",
      title: cx.t("admin.activeSessions.filter_state"),
      active: false,
      activeVariants: [],
      multiple: true,
      kind: "bitwise",
      variants: [
        ["External", STATE_EXTERNAL],
        ["Local", STATE_LOCAL],
        ["Trusted", STATE_TRUSTED],
      ],
    },
    {
      id: "status",
      title: cx.t("admin.activeSessions.filter_status"),
      active: false,
      activeVariants: [],
      multiple: true,
      kind: "bitwise",
      variants: [
        ["Expired", STATUS_EXPIRED],
        ["Locked", STATUS_LOCKED],
        ["Active", STATUS_ACTIVE],
        ["Open", STATUS_OPEN],
      ],
    },
  ];

  let srt = [
    {
      id: "byName",
      active: false,
      title: cx.t("admin.activeSessions.sort_byName"),
      value: ["name ASC"],
    },
    {
      id: "byCreatedASC",
      active: false,
      title: cx.t("admin.activeSessions.sort_byCreatedASC"),
      value: ["created ASC"],
    },
    {
      id: "byCreatedDESC",
      active: false,
      title: cx.t("admin.activeSessions.sort_byCreatedDESC"),
      value: ["created DESC"],
    },
  ];

  let filters = (
    <div
      className={`${
        showfilters ? "d-flex" : "d-none"
      }  align-items-center justify-content-end mt-0 py-5 px-7 mb-2 border-bottom w-100 shadow-sm`}
    >
      <Filters changeFn={filtersChange} filters={flt} />
    </div>
  );
  return (
    <>
      <div className="card card-custom gutter-b">
        <div className="card-header">
          <div className="card-title w-100 mr-0 d-flex align-items-center justify-content-between">
            <h3 className="card-label">{cx.t("admin.activeSessions.title")}</h3>
            <div>
              <button
                className="btn btn-light mr-2"
                onClick={() => toggleFilters(!showfilters)}
              >
                <i
                  className={`fa fa-filter p-0 ${
                    showfilters ? "text-primary" : "text-muted"
                  }`}
                ></i>
              </button>
              <Sortings changeFn={sortingsChange} sortings={srt} />
            </div>
          </div>
        </div>
        {filters}
        <div className="card-body">
          <List
            listKey="SessionsList"
            search={currentSearchJSON}
            sort={currentSortingsJSON}
            customArgs={JSON.stringify({ filter: { system: false } })}
            limit={5}
            keyField="code"
            path="/admin/session/list"
          >
            <SessionsItem />
          </List>
        </div>
      </div>
    </>
  );
}

function SessionsItem(props) {
  const cx = useContext(Context);

  const [isShown, changeIsShown] = useState(true);

  let created = new Date(props.created);
  let updated = new Date(props.updated);
  let statusLabels = [
    { mask: STATUS_ACTIVE, variant: "success", text: "active" },
    { mask: STATUS_LOCKED, variant: "danger", text: "locked" },
    { mask: STATUS_EXPIRED, variant: "warning", text: "expired" },
    { mask: STATUS_OPEN, variant: "primary", text: "open" },
  ];
  let stateLabels = [
    { mask: STATE_EXTERNAL, variant: "warning", text: "ext" },
    { mask: STATE_LOCAL, variant: "light", text: "local" },
    { mask: STATE_TRUSTED, variant: "success", text: "trusted" },
  ];

  function deleteClick() {
    cx.ask(`Сбросить сессию ${props.code}`, "Сброс сессии", "question").then(
      (answer) => {
        if (answer.value) {
          kill();
        }
      }
    );
  }

  async function kill() {
    let result = await cx.api.q("/sign/out", {
      session: props.code,
    });
    if (result !== false) {
      cx.toast(`${props.code}: Сессия сбошена`, "success");
      changeIsShown(false);
    } else {
      cx.toast(`${props.code}: Не удалось сбросить сессию`, "error");
    }
  }

  if (!isShown) return null;

  return (
    <div className="row mb-5 border-bottom pb-5">
      <div className="col-lg-6 mb-3 mb-lg-0">
        <div className="text-muted mb-2">{props.code}</div>
        {props.state > 0 ? (
          <span className="label label-success label-dot mr-2"></span>
        ) : null}
        {props.name}

        {stateLabels.map((label) =>
          props.state & label.mask ? (
            <span
              key={label.mask}
              className={`label label-${label.variant} label-inline mx-1`}
            >
              {label.text}
            </span>
          ) : null
        )}
        {statusLabels.map((label) =>
          props.status & label.mask ? (
            <span
              key={label.mask}
              className={`label label-${label.variant} label-inline mx-1`}
            >
              {label.text}
            </span>
          ) : null
        )}
      </div>
      <div className="col-lg-3 font-size-sm">
        <div>
          <i className="flaticon2-add-1 mr-2 icon-sm"></i>
          {created.toLocaleTimeString()}
          <span className="text-muted font-size-sm ml-2">
            {created.toLocaleDateString()}
          </span>
        </div>
        <div>
          <i className="flaticon2-reload mr-2 icon-sm"></i>
          {updated.toLocaleTimeString()}
          <span className="text-muted font-size-sm ml-2">
            {updated.toLocaleDateString()}
          </span>
        </div>
      </div>
      <div className="col-lg-3 font-size-sm">
        <span
          title="Сбросить"
          onClick={() => deleteClick()}
          className="float-right flaticon2-delete px-2 align-middle cursor-pointer text-muted text-hover-danger"
        ></span>
        <div>lc_ip: {props.host ? props.host : "-"}</div>
        <div>host: {props.lc_ip ? props.lc_ip : "-"}</div>
      </div>
    </div>
  );
}

export default ActiveSessions;
